<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'100px'" :search-btn-span="colSpan" :default-sort="defaultSort" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" :tooltip-config="{ contentMethod: false, enterable: true }" @afterFetchOriginalData="getTableData" @sort-change="sortChange" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col v-if="!$store.getters.cusId" :span="colSpan">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
        <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.No')" prop="orderNo">
            <BjInput v-model="queryParams.orderNo" :placeholder="$t('InternalOrder.No')" comma @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.SKU')" prop="skuCode">
            <BjInput v-model="queryParams.skuCode" :placeholder="$t('InternalOrder.SKU')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.means')" prop="shippingMethod">
            <BjSelectLov v-model="queryParams.shippingMethod" :placeholder="$t('BusinessPurchaseOrder2.means')" :option-list="CSG_ORDER_SHIPPING_METHODS_LIST" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.consignmentNum')" prop="logisticsNo">
            <BjInput v-model="queryParams.logisticsNo" :placeholder="$t('billingPage.consignmentNum')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.CourierName')" prop="logisticsCompany">
            <BjSelectLov v-model="queryParams.logisticsCompany" multiple :placeholder="$t('InternalOrder.CourierName')" :option-list="CourierNameList" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24" style="padding-left: 0;padding-right: 0;"> -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('InternalOrder.order')">
              <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('InternalOrder.order')" />
            </el-form-item>
          </el-col>
          <el-col v-if="queryParamsTradeStatus !== '2'" :span="colSpan">
            <el-form-item :label="$t('InternalOrder.orderOFF')">
              <BjDateRangePicker v-model="queryParamsTime_receive" :placeholder="$t('InternalOrder.orderOFF')" />
            </el-form-item>
          </el-col>
          <!-- totalOrderStatus： 5已完成 6已取消 ORDER_INTERNAL_YES_STATUS_LIST-->
          <el-col v-if="queryParamsTradeStatus === '0'" :span="colSpan">
            <el-form-item :label="$t('orderNewPatch.Status')" prop="totalOrderStatus">
              <BjSelectLov v-model="statusList" :placeholder="$t('orderNewPatch.Status')" multiple :option-list="ORDER_INTERNAL_YES_STATUS_LIST" @change="selectSome" />
            </el-form-item>
          </el-col>
        <!-- </el-col> -->
      </template>
      <template v-slot:beforeSearchBtn>
        <el-col :span="24 - colSpan">
          <el-tabs :value="queryParamsTradeStatus" type="card" @tab-click="handleTabClick">
            <el-tab-pane v-for="(item, index) in CSG_ORDER_INTERNAL_ORDER_STATUS_CSG_LIST" :key="index" :label="$t(item.label)" :name="item.value" />
          </el-tabs>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <BjFrontendExport
            type="primary"
            :label-list="exportLabelList"
            :rows="selectedRows"
            file-name="Closed Orders.csv"
          />
          <el-button type="primary" @click="onFullExport">{{ $t('exportFullText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <vxe-table-column v-if="col.prop === 'orderTime'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="orderTime" :title="$t('orderNewPatch.orderDate')" width="140px" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row[col.prop] | timeFilters }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column v-else-if="col.prop === 'creationDate'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" field="creationDate" :title="$t('orderNewPatch.creationDate')" width="150px" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row[col.prop] | timeFilters({ isSession: true, dateFormat: 'DD/MM/YYYY HH:mm' }) }}</span>
            </template>
          </vxe-table-column>
          <el-table-column v-else-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <template v-else-if="col.prop === 'outerOrderNo'">
                <span>{{ scope.row.webReference }}</span>
                <BjCopyIcon :copy="scope.row.webReference" />
              </template>
              <template v-else-if="col.prop === 'logisticsNo'">
                <span class="link" @click="openTrackingDetails(scope.row)">{{ scope.row[col.prop] }}</span>
              </template>
              <template v-else-if="col.prop === 'totalOrderStatus'">
                <!-- 5已完成 6已取消 -->
                <el-tag :type="scope.row[col.prop] === 5 ? 'success' : 'info'">{{ $t(ORDER_INTERNAL_YES_STATUS_LIST.bjGet(scope.row[col.prop]))}}</el-tag>
              </template>
              <template v-else-if="col.prop === 'orderHandleStatus'">
                {{ $t(ORDER_WMS_STATUS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'shippingMethod'">
                <el-tag>{{ $t(CSG_ORDER_SHIPPING_METHODS_LIST.bjGet(scope.row[col.prop])) }}</el-tag>
              </template>
              <template v-else-if="col.prop === 'receiveTime'">
                <span v-if="scope.row.totalOrderStatus === 5">{{ scope.row.receiveTime | timeFilters({ isSession: true, dateFormat: 'DD/MM/YYYY HH:mm' }) }}</span>
                <span v-if="scope.row.totalOrderStatus === 6">{{ scope.row.payTime | timeFilters({ isSession: true, dateFormat: 'DD/MM/YYYY HH:mm' }) }}</span>
              </template>
              <template v-else-if="col.prop === 'supplierName'">
                <el-tag v-if="scope.row[col.prop]=='Urgent'" type='success'>{{ scope.row[col.prop] }}</el-tag>
                <span v-else>{{ scope.row[col.prop] }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="toViewOrder(props.row)">{{ $t('viewText') }}</el-button>
              <el-dropdown v-hasDropdownChildren @command="handleActionCommand($event, props.row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="$store.getters.cusId && props.row.totalOrderStatus == '6'" command="copy">{{ $t('copyText') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!$store.getters.cusId && props.row.totalOrderStatus == '5'" :disabled="disShippingMethod(props.row)" command="customerDelivery">{{ $t('InternalSalesOrderDetails.customerDelivery') }}</el-dropdown-item>
                  <el-dropdown-item v-if="props.row.totalOrderStatus == '5' && ['AUSP','AUSX'].includes(props.row.logisticsBusinessName)" command="returnLabel">{{ $t('InternalSalesOrderDetails.ReturnLabel') }}</el-dropdown-item>
                  <el-dropdown-item v-if="showFeeButton" command="fee">{{ $t('feeTab.fee') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <delveryDialog ref="delveryDialogRef" @reFresh="reFresh" />
    <!-- 物流单号查物流弹窗 -->
    <DeliverDialog ref="DeliverDialogRef"/>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import delveryDialog from './delveryDialog';
import { orderApi, thirdApi, logisticApi } from '@/api';
import {
  CSG_ORDER_INTERNAL_ORDER_STATUS_CSG_LIST,
  ORDER_INTERNAL_HAND_UP_STATUS_LIST,
  ORDER_INTERNAL_YES_STATUS_LIST,
  CSG_ORDER_SHIPPING_METHODS_LIST,
  ORDER_WMS_STATUS_LIST,
  LANG_ZH_EN_PS_LIST,
} from '@/utils/constants';
import { downloadBlob } from '@/utils/index';
import axios from '@/utils/axios';
import DeliverDialog from '../internal/components/LogisticsTable/DeliverDialog.vue';
import { timeFilters } from '@/filters';

const sessionTimeOptions = { isSession: true, dateFormat: 'DD/MM/YYYY HH:mm' };
const RECEIVABLE_PERMISSION = 'BusinessOrderFeeTabReceivable'.toLocaleLowerCase();
const PAYABLE_PERMISSION = 'BusinessOrderFeeTabPayable'.toLocaleLowerCase();

export default {
  name: 'BusinessOrderInternalCSGAdmin',
  components: { delveryDialog, DeliverDialog },
  mixins: [pageMiXin],
  props: {},
  data() {
    return {
      selection: true,
      colSpan: 4,
      CSG_ORDER_INTERNAL_ORDER_STATUS_CSG_LIST,
      ORDER_INTERNAL_HAND_UP_STATUS_LIST,
      ORDER_INTERNAL_YES_STATUS_LIST,
      CSG_ORDER_SHIPPING_METHODS_LIST,
      ORDER_WMS_STATUS_LIST,
      LANG_ZH_EN_PS_LIST,
      queryApi: orderApi.getCSGThirdOrderPage,
      // 查询参数
      queryParamsTime_order: [],
      queryParamsTime_receive: [],
      CourierNameList: [],
      queryParams: {
        size: 20,
        page: 0,
        total: 0,
        pageSize: 20,
        currentPage: 0,

        cusId: null,
        channel: null,
        orderNo: null,
        skuCode: null,
        orderStartTime: null,
        orderEndTime: null,
        receiveStartTime: null,
        receiveEndTime: null,
        storeId: null,
        shippingMethod: null,
        storeIdList: [],
        totalOrderStatus: [5, 6],
        logisticsNo: null,
        logisticsCompany: [],

        sortParam: null,
        sortOrder: null,

      },
      statusList: [],
      queryParamsTradeStatus: '0',
      // 全部订单
      labelList1: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '120' },
        { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('InternalOrder.form.wmsOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.Status'), prop: 'totalOrderStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('billingPage.tag'), prop: 'supplierName', isCheck: true, disabled: false, width: '100'},
        { label: this.$t('orderNewPatch.wmsStatus'), prop: 'orderHandleStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
        { label: this.$t('orderNewPatch.Shipping'), prop: 'shippingMethod', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.document'), prop: 'logisticsNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.orderDate'), prop: 'orderTime', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('orderNewPatch.creationDate'), prop: 'creationDate', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.sapPushTime'), prop: 'sapPushTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.hjShipmentTime'), prop: 'hjShipmentTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.receiveTime'), prop: 'receiveTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.ShippingCost'), prop: 'totalPrice', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.Courier'), prop: 'logisticsCompany', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalSalesOrderDetails.Merchant'), prop: 'orderRemarks', isCheck: false, disabled: false, width: '180' },
        { label: this.$t('InternalSalesOrderDetails.Customer'), prop: 'serviceRemarks', isCheck: false, disabled: false, width: '180' },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '150' },
      ],
      // 已完成订单
      labelList2: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '120' },
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('InternalOrder.form.wmsOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.Status'), prop: 'totalOrderStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('billingPage.tag'), prop: 'supplierName', isCheck: true, disabled: false, width: '100'},
        { label: this.$t('orderNewPatch.wmsStatus'), prop: 'orderHandleStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
        { label: this.$t('orderNewPatch.Shipping'), prop: 'shippingMethod', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.orderDate'), prop: 'orderTime', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('orderNewPatch.creationDate'), prop: 'creationDate', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.sapPushTime'), prop: 'sapPushTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.hjShipmentTime'), prop: 'hjShipmentTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.receiveTime'), prop: 'receiveTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuantity', isCheck: true, disabled: false, width: '90' },
        { label: this.$t('InternalOrder.form.document'), prop: 'logisticsNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.ShippingCost'), prop: 'totalPrice', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.Courier'), prop: 'logisticsCompany', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalSalesOrderDetails.Customer'), prop: 'serviceRemarks', isCheck: false, disabled: false, width: '180' },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '150' },
      ],
      // 已取消订单
      labelList3: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '120' },
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('InternalOrder.form.wmsOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.Status'), prop: 'totalOrderStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.wmsStatus'), prop: 'orderHandleStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
        { label: this.$t('orderNewPatch.Shipping'), prop: 'shippingMethod', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.orderDate'), prop: 'orderTime', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('orderNewPatch.creationDate'), prop: 'creationDate', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.sapPushTime'), prop: 'sapPushTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.hjShipmentTime'), prop: 'hjShipmentTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('orderNewPatch.receiveTime'), prop: 'receiveTime', isCheck: true, disabled: false, width: '140'},
        { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuantity', isCheck: true, disabled: false, width: '90' },
        { label: this.$t('InternalOrder.form.document'), prop: 'logisticsNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.ShippingCost'), prop: 'totalPrice', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.Courier'), prop: 'logisticsCompany', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalSalesOrderDetails.Customer'), prop: 'serviceRemarks', isCheck: false, disabled: false, width: '180' },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '150' },
      ],
      defaultSort: [],
    };
  },
  computed: {
    labelList() {
      const hiddenUserProps = ['cusId', 'orderHandleStatus', 'hjShipmentTime'];
      if (this.queryParamsTradeStatus === '0') {
        return this.$store.getters.cusId ? this.labelList1.filter(item => !hiddenUserProps.includes(item.prop)) : this.labelList1;
      } else if (this.queryParamsTradeStatus === '1') {
        return this.$store.getters.cusId ? this.labelList2.filter(item => !hiddenUserProps.includes(item.prop)) : this.labelList2;
      } else {
        return this.$store.getters.cusId ? this.labelList3.filter(item => !hiddenUserProps.includes(item.prop)) : this.labelList3;
      }
    },
    exportLabelList() {
      const exportConfigs = {
        cusId: { options: () => this.customerList },
        totalOrderStatus: { options: ORDER_INTERNAL_YES_STATUS_LIST, translate: true },
        orderHandleStatus: { options: ORDER_WMS_STATUS_LIST, translate: true },
        shippingMethod: { options: CSG_ORDER_SHIPPING_METHODS_LIST, translate: true },
        orderTime: { formatter: value => timeFilters(value) },
        creationDate: { formatter: value => timeFilters(value, sessionTimeOptions) },
        sapPushTime: { formatter: value => timeFilters(value) },
        hjShipmentTime: { formatter: value => timeFilters(value) },
        receiveTime: { formatter: (value, row) => row.totalOrderStatus === 5
          ? timeFilters(row.receiveTime, sessionTimeOptions)
          : (row.totalOrderStatus === 6 ? timeFilters(row.payTime, sessionTimeOptions) : '') },
      };
      return this.labelList.map(column => exportConfigs[column.prop]
        ? { ...column, export: exportConfigs[column.prop] }
        : column);
    },
    permissionBtns() {
      return this.$store.getters.userPermissionBtns || [];
    },
    showFeeButton() {
      return [RECEIVABLE_PERMISSION, PAYABLE_PERMISSION].some(permission => this.permissionBtns.includes(permission));
    },
  },
  watch: {
    queryParamsTime_order(v) {
      this.queryParams.orderStartTime = (v || [])[0];
      this.queryParams.orderEndTime = (v || [])[1];
    },
    queryParamsTime_receive(v) {
      this.queryParams.receiveStartTime = (v || [])[0];
      this.queryParams.receiveEndTime = (v || [])[1];
    },
  },
  mounted() {
    this.$store.dispatch('values/getTags');
    this.getLogisticsDataList()
  },
  methods: {
    // 获取物流下拉数据
    getLogisticsDataList() {
      logisticApi.getLogisticsBusiness({
          currentPage: 0,
          page: 0,
          pagesize: 999,
          size: 999,
        }).then(res => {
        this.CourierNameList = res.content.map(item => {
          return {
            label: item.name,
            value: item.name
          };
        });
      });
    },
    // 根据物流单号获取弹框数据并打开弹窗
    openTrackingDetails(row){
      this.$refs.DeliverDialogRef.show(row)
    },
    disShippingMethod(row) {
      return !((row.totalOrderStatus == 5 || row.totalOrderStatus == 7) && row.takingDeliveryWay == 1);
    },
    handleActionCommand(command, row) {
      switch (command) {
        case 'copy':
          this.toCopyOrder(row);
          break;
        case 'customerDelivery':
          this.customerDelivery(row);
          break;
        case 'returnLabel':
          this.goReturnDetail(row);
          break;
        case 'fee':
          this.toFeePage(row);
          break;
      }
    },
    // 获取tableData数据
    getTableData(data) {
      data.content.forEach(item => {
        if (item.shippingMethod.toLowerCase() == 'pickup') {
          item.logisticsNo = null;
          item.totalPrice = null;
          item.logisticsCompany = null;
        }
      });
      return data;
    },
    // 全量导出
    onFullExport() {
      orderApi.getCSGThirdOrderPage(this.queryParams).then(res=>{
        this.$confirm(`${this.$t('toast.AboutToExport')}${res.totalElements}${this.$t('toast.waitText')}`, this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(async () => {
            const Ids = [];
            const res = await thirdApi.csgOrderImport(this.queryParams);
            if (res.children.length > 0) {
                res.children.forEach(item => Ids.push(item.id));
                axios({
                    method: 'post',
                    url: `/third-adapter/v1/${this.$store.getters.tenantId}/third-order/csg-order-import?rType=2&fillerType=single-sheet&exportType=DATA&ids=${Ids.join(',')}`,
                    data: this.queryParams,
                    responseType: 'blob'
                }).then((res) => {
                  downloadBlob(res.data, 'Closed Orders.xlsx');
                  this.$refs.BjPage.onResetQuery();
                });
            }
          })
          .catch(() => {});
      })
    },
    sortChange (column) {
      switch (column.property) {
        case 'orderTime':
          this.queryParams.sortParam = column.property;
          this.queryParams.sortOrder = column.order;
          break;
        case 'creationDate':
          this.queryParams.sortParam = column.property;
          this.queryParams.sortOrder = column.order;
          break;
      }
      this.defaultSort = [{ field: column.field, order: column.order }];
      this.$refs.BjPage.fetchData();
    },
    // 订单状态 下拉框事件
    selectSome(val) {
      if (val.length > 0) {
        this.queryParams.totalOrderStatus = val;
      } else {
        this.queryParams.totalOrderStatus = [5, 6];
      }
    },
    // tab页点击事件
    handleTabClick(tab, event) {
      this.queryParamsTradeStatus = tab.name;
      this.queryParamsTime_order = null;
      this.queryParamsTime_receive = null;
      this.queryParams={
        cusId: null,
        channel: null,
        orderNo: null,
        orderStartTime: null,
        orderEndTime: null,
        receiveStartTime: null,
        receiveEndTime: null,
        storeId: null,
        storeIdList: [],

        size: 20,
        page: 0,
        pageSize: 20,
        currentPage: 0,
        total: 0,
      }
      // tab.name = '0', tab.label = "已完成订单"
      if (tab.name == '0') {
        this.statusList = [];
        this.queryParams.shippingMethod = null;
        this.queryParams.totalOrderStatus = [5, 6]
      } else if (tab.name == '1') {
        this.queryParams.totalOrderStatus =[5]
      } else {
        this.queryParams.totalOrderStatus =[6]
      }
      setTimeout(() => { this.reFresh(); }, 500);
    },
    toViewOrder(row) {
      // 5已完成 6已取消
      // 有内部订单号 内部详情
      if (row.innerOrderNo) {
        this.toInnerOrder(row);
      } else {
        this.toThirdOrder(row);
      }
    },
    // 跳转外部订单详情
    toThirdOrder(row) {
      this.$router.push({
        name: 'BusinessThirdOrderCSGView',
        query: { id: '', code: encodeURIComponent(row.outerOrderNo), status: row.totalOrderStatus, type: 'view' },
      });
    },
    // 跳转内部订单详情
    toInnerOrder(row) {
      this.$router.push({
        name: 'BusinessOrderInternalViewCSG',
        query: { id: '', code: encodeURIComponent(row.innerOrderNo), status: row.totalOrderStatus },
      });
    },
    // 跳转复制订单
    toCopyOrder(item) {
      this.$router.push({
        name: 'BusinessOrderInternalAddCSG',
        query: { id: '', code: encodeURIComponent(item.outerOrderNo), status: item.totalOrderStatus },
      });
    },
    // 用户提货
    customerDelivery(item) {
      if(item.shippingMethod.toLowerCase().includes("csg manual") && (!item.logisticsNo || item.logisticsNo == ' ')){
        return this.$message.warning(this.$t('InternalOrder.ps2'));
      }
      this.$refs.delveryDialogRef.dialogVisible = true;
      this.$refs.delveryDialogRef.selectedRows = [item.innerOrderNo];
      // 获取当前时间  
      const now = new Date();
      const startOfWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1); 
      this.$refs.delveryDialogRef.pickerOptions = {
        disabledDate(time) { 
          // 如果选择的时间小于本周一的时间，则禁用
          if(new Date(item.receiveTime).getTime() > startOfWeek.getTime()){
            return time.getTime() < new Date(item.receiveTime).getTime();
          }else{
            return time.getTime() < startOfWeek.getTime();
          }
        },
      }
    },
    toFeePage(row) {
      this.$router.push({
        name: 'BusinessOrderInternalCSGFEE',
        query: { outerOrderNo: row.outerOrderNo },
      });
    },
    // 带参数直接去往 退件详情页
    goReturnDetail(row){
      orderApi.overOrderCreateReturnOrder({outerOrderNo: encodeURIComponent(row.outerOrderNo)}).then(res => {
        if (res.id) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            // 跳退件详情页
            this.$router.push({
              name: 'BusinessAfterReturnView',
              query: { id: res.id },
            });
          }, 1000);
        }
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_order = null;
      this.queryParamsTime_receive = null;
      this.queryParams.storeIdList = null;
      this.queryParams.cusId = null;
      this.statusList = [];
      if (this.queryParamsTradeStatus == '0') {
        this.queryParams.totalOrderStatus = [5, 6];
      } else if (this.queryParamsTradeStatus == '2') {
        this.queryParams.totalOrderStatus = [6];
      } else {
        this.queryParams.totalOrderStatus = [5];
      }
      this.defaultSort = [];
      this.queryParams.sortParam = null;
      this.queryParams.sortOrder = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>

<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
